import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
// import swal from 'sweetalert'
import createPersistedState from 'vuex-persistedstate'
var wishListData = []
Vue.use(Vuex)
const state = {
  wishList: []
}
const getters = {
  // returns the filltered wishList content
  getWishListDataMatchingKeyWord: (state, getters) => keyWord => {
    var result = []
    if (keyWord.length === 0) {
      result = getters.getWishListStoreData
    } else {
      result = getters.getWishListStoreData.filter(obj => {
        return obj.itemName.toLowerCase().includes(keyWord.toLowerCase())
      })
    }
    return result
  },
  // returns True or False depending on whether item is present in wishList
  itemPresentInWishListStatus: (state, getters) => itemId => {
    for (var i = 0; i < getters.getWishListStoreData.length; i++) {
      if (getters.getWishListStoreData[i].itemId === itemId) {
        return true
      }
    }
    return false
  },
  // returns only those items present in wishList and not in cart
  getWishListDataNotPresentInCart: (state, getters) => searchParameters => {
    wishListData = []
    getters.getWishListStoreData.forEach(element => {
      var isExist = false
      searchParameters.items.forEach(element1 => {
        if (element1.itemId === element.itemId) {
          isExist = true
        }
      })
      if (!isExist) {
        wishListData.push(element)
      }
    })
    return wishListData
  },
  // returns data present in wishList
  getWishListStoreData: function (state) {
    return state.wishList
  }
}
const actions = {
  insertWishListInDb (context, data) {
    return new Promise((resolve, reject) => {
      axios
      .post('r/addWishListItems', {
        'profileId': data.profileId, 'itemId': data.itemId
      })
      .then(response => {
        context.commit('setWishListStoreData', response.data)
        resolve()
      })
      .catch(e => {
        console.log('Catch', e)
        reject(e)
      })
    })
  },
  removeWishListFromDb (context, data) {
    return new Promise((resolve, reject) => {
      axios
       .post('r/deleteWishListItems', {
         'profileId': data.profileId, 'itemId': data.itemId
       })
      .then(response => {
        // alert(JSON.stringify(response.data))
        context.commit('setWishListStoreData', response.data)
        resolve()
      })
      .catch(e => {
        console.log('Catch', e)
        reject(e)
      })
    })
  },
  getWishListFromDb (context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('r/viewWishListItems', {
          'profileId': data
        })
        .then(response => {
          context.commit('setWishListStoreData', response.data)
          resolve()
        })
        .catch(e => {
          console.log('Catch', e)
          reject(e)
        })
    })
  },
  resetWishListInStore (context) {
    context.commit('clearWishListStoreData')
  }
}
const mutations = {
  setWishListStoreData (state, data) {
    if (data === null) {
      state.wishList = []
    } else {
      state.wishList = data
    }
  },
  clearWishListStoreData (state) {
    state.wishList = []
  }
}
export default {
  state,
  actions,
  getters,
  mutations,
  plugins: [createPersistedState({ storage: window.localStorage })]
}



// WEBPACK FOOTER //
// ./src/store/modules/wishList.js